module.exports = __webpack_public_path__ + "static/img/image17.7795b53f.png";